import FieldMixinForResponse from './mixin.js';

const SectionBreakForResponse = {
  mixins: [FieldMixinForResponse],

  props: {
    field: {
      type: Object
    },
    extendClass: {
      default: ''
    },
    message: {
      type: String,
      default: ''
    }
  },

  template: `
    <div
      v-show='visible'
      :class='[fieldCommonClass, fieldDifferenceClass]'
      class="form-field"
    >
      <div class="form-field-head">
        <div class="form-field-title" v-if='field.title'>{{ field.title }}</div>
        <div class="form-field-description" v-html='field.description'></div>
      </div>
    </div>
  `,

  computed: {
    fieldDifferenceClass: function() {
      return {
        'section-break-field': true
      };
    }
  },

  methods: {
    getEntries: function() {
      return [];
    }
  }
};

export default SectionBreakForResponse;
